module.exports = __webpack_public_path__ + "static/media/East africa1.2d57d767.gif";